<template lang="pug">
transition(name="fade")
  .InlineFrameModal
    .inner
      iframe.iframe(:src="src")
      .closeButton(@click="handleCloseButtonClick")
        font-awesome-icon.icon(icon="times-circle")
    .bg(@click="handleBgClick")
</template>

<script>
export default {
  name: 'km-inline-frame-modal',
  components: {},
  props: {
    src: {
      type: String,
      default: ''
    }
  },
  data() {
    return {}
  },
  computed: {},
  methods: {
    handleMuteSettingSwitchClick() {},
    handleCloseButtonClick() {
      this.$emit('onClose')
    },
    handleBgClick() {
      this.$emit('onClose')
    }
  }
}
</script>

<style lang="scss" scoped>
.InlineFrameModal {
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  z-index: 1;
}

.inner {
  position: relative;
  top: -40px;
  width: 800px;
  height: 600px;
  padding: 10px;
  background: #fff;
  text-align: center;
  border-radius: 10px;
  z-index: 2;
}

.iframe {
  width: 100%;
  height: 100%;
  border: 0;
}

.closeButton {
  position: absolute;
  top: -15px;
  right: -15px;
  display: inline-block;
  padding: 3px;
  background: #333;
  color: #fff;
  line-height: 1;
  font-size: 3rem;
  border-radius: 50%;
}

.bg {
  position: absolute;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1;
}
</style>
